import { TrophyIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Trophy = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <TrophyIcon {...rest} size={Sizes[size]} color={fill} />;
};

Trophy.displayName = 'Trophy';
